import Client from '../HttpClient';

const list = (data) => {
	return Client.get('/gateway/eagle-mgt/order/list', data);
};

const find = (OnlineOrderId) => {
	return Client.get(`/gateway/eagle-mgt/order/${OnlineOrderId}`);
};

const findReturnItem = (id) => {
	return Client.get(`/gateway/eagle-mgt/api/vs/manager/return_item/${id}`);
};

const addNote = (val) => {
	return Client.post('/gateway/eagle-mgt/order/update/note', val);
};

const getOrderRefund = (OnlineOrderId, val) => {
	return Client.get(
		`/gateway/eagle-mgt/api/vs/manager/order_refunds/${OnlineOrderId}`,
		val
	);
};

const getOrderReturnApply = (OnlineOrderId, val) => {
	return Client.get(
		`/gateway/eagle-mgt/api/vs/manager/return_apply/${OnlineOrderId}`,
		val
	);
};

const getOrderOperateHistory = (OnlineOrderId) => {
	return Client.get(`/gateway/eagle-mgt/order-history/list/${OnlineOrderId}`);
};

const getOrderSettings = (data) => {
	return Client.get('/gateway/eagle-mgt/orderSetting', data);
};

const updateOrderSettings = (data) => {
	return Client.post('/gateway/eagle-mgt/orderSetting/update', data);
};

const getPreparationTimeList = (data) => {
	return Client.get(
		'/gateway/eagle-mgt/api/vs/manager/omsPreparationSettings',
		data
	);
};

const addPreparationTime = (data) => {
	return Client.post(
		'/gateway/eagle-mgt/api/vs/manager/omsPreparationSettings',
		data
	);
};

const updatePreparationTime = (id, data) => {
	return Client.put(
		`/gateway/eagle-mgt/api/vs/manager/omsPreparationSettings/${id}`,
		data
	);
};

const deletePreparationTime = (id, data) => {
	return Client.del(
		`/gateway/eagle-mgt/api/vs/manager/omsPreparationSettings/${id}`,
		data
	);
};

const getDeliveryTimeList = (data) => {
	return Client.get(
		'/gateway/eagle-mgt/api/vs/manager/omsDeliveryTimeSettings',
		data
	);
};

const addDeliveryTimeSingle = (data) => {
	return Client.post(
		'/gateway/eagle-mgt/api/vs/manager/omsDeliveryTimeSetting',
		data
	);
};

const addDeliveryTime = (data) => {
	return Client.post(
		'/gateway/eagle-mgt/api/vs/manager/omsDeliveryTimeSettings',
		data
	);
};

const updateDeliveryTime = (id, data) => {
	return Client.put(
		`/gateway/eagle-mgt/api/vs/manager/omsDeliveryTimeSettings/${id}`,
		data
	);
};

const deleteDeliveryTime = (id, data) => {
	return Client.del(
		`/gateway/eagle-mgt/api/vs/manager/omsDeliveryTimeSettings/${id}`,
		data
	);
};

const getSpecialDay = (data) => {
	return Client.get(
		'/gateway/eagle-mgt/api/vs/manager/omsDeliveryTimeSettings/day',
		data
	);
};

const loadMerchantList = () => {
	return Client.get('/gateway/echidna-api/api/vs/resource/eagle-mgt');
};

const loadBranchList = (merchantId) => {
	return Client.get(
		`/gateway/echidna-api/api/vs/user/online-order/branch/${merchantId}`
	);
};

const mgtBranchListCheckLicense = (data) => {
	return Client.post(
		'/gateway/eagle-mgt/api/vs/manager/branches/checkLicense',
		data
	);
};

const deliveryMethodList = (merchantId, data) => {
	return Client.get(
		`/gateway/eagle-mgt/api/vs/manager/${merchantId}/merchantDeliveryMethods`,
		data
	);
};

const deliveryFeeList = (merchantId, data) => {
	return Client.get(
		`/gateway/eagle-mgt/api/vs/manager/${merchantId}/merchantDeliveryFees`,
		data
	);
};

const payMethodList = (merchantId, data) => {
	return Client.get(
		`/gateway/eagle-mgt/api/vs/manager/${merchantId}/merchantPaymentMethods`,
		data
	);
};

const updateBranchOnline = (data) => {
	return Client.put('/gateway/eagle-mgt/api/vs/manager/branch', data);
};

const updateDeliveryMethod = (merchantId, id, data) => {
	return Client.put(
		`/gateway/eagle-mgt/api/vs/manager/${merchantId}/merchantDeliveryMethods/${id}`,
		data
	);
};

const addDeliveryMethod = (merchantId, data) => {
	return Client.post(
		`/gateway/eagle-mgt/api/vs/manager/${merchantId}/merchantDeliveryMethods`,
		data
	);
};

const addDeliveryFee = (merchantId, data) => {
	return Client.post(
		`/gateway/eagle-mgt/api/vs/manager/${merchantId}/merchantDeliveryFees`,
		data
	);
};

const updateDeliveryFee = (merchantId, id, data) => {
	return Client.put(
		`/gateway/eagle-mgt/api/vs/manager/${merchantId}/merchantDeliveryFees/${id}`,
		data
	);
};

const deleteDeliveryFee = (merchantId, id, data) => {
	return Client.del(
		`/gateway/eagle-mgt/api/vs/manager/${merchantId}/merchantDeliveryFees/${id}`,
		data
	);
};

const getProfileOption = (merchantId, data) => {
	return Client.get(
		`/gateway/eagle-mgt/api/vs/manager/${merchantId}/pmsProfileOptions`,
		data
	);
};

const updateProfileOption = (merchantId, id, data) => {
	return Client.put(
		`/gateway/eagle-mgt/api/vs/manager/${merchantId}/pmsProfileOptions/${id}`,
		data
	);
};

const getBranchSettings = (merchantId, data) => {
	return Client.get(
		`/gateway/eagle-mgt/api/vs/manager/branch-setting/${merchantId}`,
		data
	);
};

const postBranchSettings = (merchantId, data) => {
	return Client.post(
		`/gateway/eagle-mgt/api/vs/manager/branch-setting/${merchantId}`,
		data
	);
};

const downloadList = (data) => {
	return Client.get(`/gateway/eagle-mgt/order/list/download`, data, {
		responseType: 'blob',
	});
};

const getRefundList = (merchantId, data) => {
	return Client.get(
		`/gateway/eagle-mgt/api/vs/manage/${merchantId}/omsOrderRefundApplys`,
		data
	);
};

const postRefundList = (merchantId, data) => {
	return Client.post(
		`/gateway/eagle-mgt/api/vs/manage/${merchantId}/omsOrderRefundApplys`,
		data
	);
};

const postDeliveryCloseTime = (data) => {
	return Client.post(
		`/gateway/eagle-mgt/api/vs/manager/omsDeliveryCloseTimeSetting`,
		data
	);
};

const putDeliveryCloseTime = (id, data) => {
	return Client.put(
		`/gateway/eagle-mgt/api/vs/manager/omsDeliveryCloseTimeSettings/${id}`,
		data
	);
};

const getAllChannelMenuGroups = (merchantId, branchId) => {
	return Client.get(
		`/gateway/eagle-mgt/api/vs/manage-channel-menu-group/${merchantId}/${branchId}/allChannels`
	);
};

const updateChannelMenuGroups = (merchantId, branchId, channelName, data) => {
	return Client.put(
		`/gateway/eagle-mgt/api/vs/manage-channel-menu-group/${merchantId}/${branchId}/channelMenuGroups/${channelName}`,
		data
	);
};

const getBranchChannelMenuGroups = (merchantId, branchId) => {
	return Client.get(
		`/gateway/eagle-mgt/api/vs/manage-channel-menu-group/${merchantId}/${branchId}/menu-groups`
	);
};

const syncChannelMenuGroups = (
	merchantId,
	branchId,
	channelName,
	operateBy
) => {
	return Client.post(
		`/gateway/eagle-mgt/api/vs/manage-channel-menu-group/${merchantId}/${branchId}/syncChannelMenu/${channelName}`,
		{ operateBy }
	);
};

const syncAllChannelMenu = (merchantId, branchId, operateBy) => {
	return Client.post(
		`/gateway/eagle-mgt/api/vs/manage-channel-menu-group/${merchantId}/${branchId}/syncAllChannelMenu`,
		{ operateBy }
	);
};

export default {
	list,
	find,
	findReturnItem,
	addNote,
	getOrderRefund,
	getOrderReturnApply,
	getOrderOperateHistory,
	getOrderSettings,
	updateOrderSettings,
	getPreparationTimeList,
	addPreparationTime,
	updatePreparationTime,
	deletePreparationTime,
	getDeliveryTimeList,
	addDeliveryTime,
	addDeliveryTimeSingle,
	updateDeliveryTime,
	deleteDeliveryTime,
	getSpecialDay,
	loadMerchantList,
	loadBranchList,
	mgtBranchListCheckLicense,
	deliveryMethodList,
	deliveryFeeList,
	payMethodList,
	updateBranchOnline,
	updateDeliveryMethod,
	addDeliveryMethod,
	addDeliveryFee,
	updateDeliveryFee,
	deleteDeliveryFee,
	getProfileOption,
	updateProfileOption,
	getBranchSettings,
	postBranchSettings,
	downloadList,
	getRefundList,
	postRefundList,
	postDeliveryCloseTime,
	putDeliveryCloseTime,
	getAllChannelMenuGroups,
	updateChannelMenuGroups,
	getBranchChannelMenuGroups,
	syncChannelMenuGroups,
	syncAllChannelMenu,
};
